import { useEffect } from "react";

import useTranslation from "../../utils/use-translations";

const stringGroups = [
  {
    key: "shared",
    values: ["myInstitute"],
  }
];

const useTranslatedTitle = ({ menuTitle }) => {

  const { managedStrings } = useTranslation(stringGroups);

  useEffect(() => {
    let title = managedStrings.myInstitute || 'myInstitute';
    if (menuTitle) {
      title = `${title} - ${menuTitle}`;
    };
    document.title = title;
  }, [managedStrings, menuTitle]);
}

export default useTranslatedTitle;